module.exports = __webpack_public_path__ + "media/images/banner4-873f77f3654d9cf42733e845c95bea7e.jpg";